import Vue from 'vue'
import VueMatchMedia from 'vue-match-media/src'

Vue.use(VueMatchMedia)

export default {}



// WEBPACK FOOTER //
// ./src/initializers/vue-match-media.js